import './images.css'

export default ({image, height, width, className}: {
    image: string;
    height?: string;
    width?: string;
    className?: string;
}) => (
    <img src={image} alt="logo" height={height} width={width} className={`img ${className}`}/>
)